import React, { useEffect } from 'react'
import className from 'classnames/bind'
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc'
import { useHistory } from 'react-router'

import style from './MyhouseSettingList.module.scss'

import MyhouseSettingItem from '@Components/atoms/MyhouseSettingItem'
import { MyhouseLabelType } from '@Root/utils/houseLabelUtils'
import useSetting from '@Hooks/myhouse/setting/useSetting'
import useModal from '@Hooks/myhouse/useModal'
import useDebounce from '@Hooks/common/useDebounce'
import useToast from '@Hooks/myhouse/useToast'
import { FETCH_STATUS } from '@Root/contants'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { TOAST_AFTER_EVENT } from '@Root/contants/myhouseToast'

const cx = className.bind(style)

// SortableElement
const SortableItemHtml = SortableElement(({ index, house }: { index: number; house: MyhouseLabelType }) => (
  <div key={`item-${index}`} className={cx('myhouse_list_item')}>
    <MyhouseSettingItem house={house} />
  </div>
))

// SortableContainer
const SortableContainerWrapper = SortableContainer(({ children }: { children: any }) => {
  return <div>{children}</div>
})

const MyhouseSettingList: React.FC = () => {
  const { modal, clean } = useModal()
  const { show } = useToast()
  const history = useHistory()
  const { loadHouseList, setReorderHouse, loadRemoveHouse, reduxSetting, initFetchStatusRemove } = useSetting()
  const { houseLabel, removeHouseNo, fetchStatusRemove, fetchStatus } = reduxSetting

  const { landDebounce } = useDebounce()
  const debouncedLoadRemoveHouse = landDebounce(loadRemoveHouse)

  useEffect(() => {
    loadHouseList()
  }, [])

  useEffect(() => {
    if (modal.confirmModal === MODAL_TYPE.DELETE_MYHOUSE) {
      clean()
      debouncedLoadRemoveHouse({ houseNo: removeHouseNo })
    }
  }, [modal.confirmModal])

  useEffect(() => {
    if (fetchStatusRemove === FETCH_STATUS.SUCCESS) {
      initFetchStatusRemove()
      if (houseLabel?.length === 0) {
        show('우리집이 삭제되었습니다.', TOAST_AFTER_EVENT.HISTORY_REPLACE, `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/regist/guide`)
        return
      }

      show('우리집이 삭제되었습니다.')
    }
  }, [fetchStatusRemove])

  useEffect(() => {
    if (fetchStatus === FETCH_STATUS.SUCCESS && houseLabel?.length === 0) {
      history.replace(`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/regist/guide`)
    }
  }, [fetchStatus])

  const onSortEnd = ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }, e: React.SyntheticEvent) => {
    handleNclick(NCLICK.MY_HOUSE.SETTING.MOVE, e)
    setReorderHouse(arrayMove(houseLabel, oldIndex, newIndex))
  }

  return (
    <>
      <div className={cx('myhouse_list_inner')}>
        <SortableContainerWrapper useDragHandle={true} onSortEnd={onSortEnd} useWindowAsScrollContainer={true}>
          {houseLabel && houseLabel.map((house: MyhouseLabelType, index: number) => <SortableItemHtml key={`item-${index}`} index={index} house={house} />)}
        </SortableContainerWrapper>
      </div>
    </>
  )
}

export default MyhouseSettingList
